export const clustersStyles = [
  {
    url: "/modules/custom/custom_react_maps/img/clusters/m1.png",
    height: 53,
    width: 55,
    textColor: "white",
    textSize: 14
  },
  {
    url: "/modules/custom/custom_react_maps/img/clusters/m2.png",
    height: 55,
    width: 56,
    textColor: "white",
    textSize: 14
  },
  {
    url: "/modules/custom/custom_react_maps/img/clusters/m3.png",
    height: 65,
    width: 66,
    textColor: "white",
    textSize: 14
  },
  {
    url: "/modules/custom/custom_react_maps/img/clusters/m4.png",
    height: 81,
    width: 73,
    textColor: "white",
    textSize: 14
  },
  {
    url: "/modules/custom/custom_react_maps/img/clusters/m5.png",
    height: 87,
    width: 90,
    textColor: "white",
    textSize: 14
  }
];
